<script lang="ts">
	//Svelte Hooks
	import { createEventDispatcher } from 'svelte';

	//Design system components
	import { ControlsContainer, Icon, IconButton, Text, Tooltip } from '@Shelly/shelly-design-system';

	//Services
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';

	const dispatch = createEventDispatcher();

	let className = '';
	export { className as class };
	export let showSaveButton = false;
	export let selectedColor: { r: number; g: number; b: number } = {
		r: 0,
		g: 0,
		b: 0,
	};

	const onClick = () => {
		dispatch('save_color', selectedColor); //
	};
</script>

<ControlsContainer class={className} color={$showNewLayout ? 'color-0' : 'color-2'}>
	<svelte:fragment slot="first">
		<div class="color-container">
			<Text styleType="controls-small" class="text-bold"
				>{capFirstChar($format('label_color', { default: 'Color' }))}</Text
			>
			<span
				class="selected-color"
				style={`background-color: rgb(${selectedColor.r},${selectedColor.g}, ${selectedColor.b});`}
			/>
			{#if showSaveButton}
				<IconButton
					aria-label={$format('save_color', { default: 'Save color' })}
					icon="fa-solid fa-floppy-disk"
					size="s"
					on:click={onClick}
				/>
			{:else}
				<Tooltip
					placement="top"
					title={$format('title_already_saved', { default: 'Already saved' })}
				>
					<Icon icon="fas fa-check" class="text-success" />
				</Tooltip>
			{/if}
		</div>
	</svelte:fragment>
</ControlsContainer>

<style s>
	/* this is temporary css solution */
	.color-container {
		display: flex;
		align-items: center;
	}

	.selected-color {
		flex: 1;
		height: 32px;
		margin-left: var(--spacing-s);
		margin-right: var(--spacing-s);
		border-radius: var(--radius-small);
	}
</style>
